export function formatAge(age: number, ageMonths?: number) {
  const ageYearsStr = age !== 0 ? `${age}Y` : '';
  const ageMonthsStr = ageMonths ? `${ageMonths}M` : '';
  const separator = ageYearsStr && ageMonthsStr ? ', ' : '';
  return ageYearsStr + separator + ageMonthsStr;
}
